import React, { useEffect, lazy, Suspense } from 'react';
import {
  Route,
  Switch,
  useHistory,
  Redirect,
  useLocation
} from 'react-router-dom';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import queryString from 'query-string';

import { selectIsAuthenticated } from 'redux/global/global.selectors';
import { setAuthenticated, logout } from 'redux/global/global.actions';

import { setAuthorizationToken } from 'api/axios_config';
import { authen_api } from 'api/authen_api';

// import PrivateRouter from 'router/PrivateRouter';

import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import buddhistUtils from './helper/buddhistUtils';
import dayjs from 'dayjs';
import 'dayjs/locale/th'; // load on demand
import isToday from 'dayjs/plugin/isToday';
dayjs.locale('th'); //use Spanish locale globally
dayjs.extend(isToday);

const MainPage = lazy(() => import('./pages/Main'));
const Cif = lazy(() => import('./pages/CIF'));
const Login = lazy(() => import('./pages/Login'));

const App = ({ isAuthenticated, setAuthenticated, logout }) => {
  const history = useHistory();
  const location = useLocation();

  const handleLogout = async () => {
    try {
      const { data } = await authen_api.logout({});
      if (data.code !== 0) {
        console.error(data.message);
      } else {
        logout();
        history.push('/login');
      }
    } catch (error) {
      if (error?.response?.data?.code) {
        console.error(error.response.data.message);
      } else {
        console.error(error);
      }
    }
  };

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      const { session_exp, url } = queryString.parse(location.search);
      if (session_exp) {
        console.error(`Session expired: ${session_exp}, URL: ${url}`);
      }
      history.push(`/login${location?.search ? location?.search : ''}`);
    } else {
      if (!isAuthenticated) {
        setAuthorizationToken(token);
        (async () => {
          try {
            const { data } = await authen_api.get_user_role();
            if (data.code !== 0) {
              console.error(data.message);
              await handleLogout();
            } else {
              const { account_name, token, role_list, user_info } = data.data;
              setAuthenticated({
                isAuthenticated: true,
                token,
                user: {
                  accountName: account_name,
                  userInfo: user_info,
                  roles: role_list
                }
              });
            }
          } catch (error) {
            const data = error?.response?.data;
            if (data) {
              console.error(data.message);
            } else {
              console.error(error);
            }
            await handleLogout();
          }
        })();
      }
    }
  }, [isAuthenticated]);

  return (
    <div>
      <MuiPickersUtilsProvider utils={buddhistUtils}>
        <Suspense fallback={<div>Loading...</div>}>
          {isAuthenticated ? (
            <Switch>
              <Route path="/cif" component={Cif} />
              <Route path="/:pageName" component={MainPage} />
              <Route
                exact
                path="/"
                render={() => <Redirect to={{ pathname: '/dashboard' }} />}
              />
            </Switch>
          ) : (
            <Switch>
              <Route path="/login" component={Login} />
            </Switch>
          )}
        </Suspense>
      </MuiPickersUtilsProvider>
    </div>
  );
};

const mapStateToProps = createStructuredSelector({
  isAuthenticated: selectIsAuthenticated
});

const mapDispatchToProps = (dispatch) => ({
  setAuthenticated: (payload) => dispatch(setAuthenticated(payload)),
  logout: () => dispatch(logout())
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
